var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23709 5.9375H0.779297V16.9642H4.23709V5.9375Z",
    stroke: "#173F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5903 5.69988C13.4629 5.68394 13.3274 5.67598 13.192 5.66801C11.2559 5.58834 10.1644 6.73562 9.78201 7.22959C9.67843 7.36503 9.63063 7.44471 9.63063 7.44471V5.97077H6.32422V16.9974H9.63063H9.78201C9.78201 15.8741 9.78201 14.7586 9.78201 13.6353C9.78201 13.0297 9.78201 12.4242 9.78201 11.8187C9.78201 11.0698 9.72624 10.2731 10.1007 9.5879C10.4194 9.01426 10.993 8.72743 11.6384 8.72743C13.5505 8.72743 13.5903 10.4563 13.5903 10.6157C13.5903 10.6236 13.5903 10.6316 13.5903 10.6316V17.0452H17.0481V9.85082C17.0481 7.38894 15.7973 5.9389 13.5903 5.69988Z",
    stroke: "#173F5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50774 4.51549C3.61659 4.51549 4.5155 3.6166 4.5155 2.50775C4.5155 1.3989 3.61659 0.5 2.50774 0.5C1.3989 0.5 0.5 1.3989 0.5 2.50775C0.5 3.6166 1.3989 4.51549 2.50774 4.51549Z",
    stroke: "#173F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.659fd4cc6ef71bcef17ceb0b2c98312c.svg";
export { ForwardRef as ReactComponent };